// src/pages/user_role_events/UserRoleEventList.js
import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Paper,
  Snackbar,
  Alert,
  Box,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import userRoleEventService from '../../services/userRoleEventService';
import LayoutContainer from '../../components/LayoutContainer';
import AdminHeader from '../../components/AdminHeader';

const UserRoleEventList = () => {
  const [userRoleEvents, setUserRoleEvents] = useState([]);
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: '',
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserRoleEvents = async () => {
      try {
        const response = await userRoleEventService.getUserRoleEvents();
        setUserRoleEvents(response.data);
      } catch (error) {
        setNotification({
          open: true,
          message: 'Error fetching events',
          severity: 'error',
        });
      }
    };
    fetchUserRoleEvents();
  }, []);

  const handleDelete = async (id) => {
    try {
      await userRoleEventService.deleteUserRoleEvent(id);
      setUserRoleEvents(
        userRoleEvents.filter((userRoleEvent) => userRoleEvent.id !== id)
      );
      setNotification({
        open: true,
        message: 'User Role Event deleted successfully',
        severity: 'success',
      });
    } catch (error) {
      setNotification({
        open: true,
        message: 'Error deleting event',
        severity: 'error',
      });
    }
  };

  const handleClose = () => {
    setNotification({ ...notification, open: false });
  };

  return (
    <LayoutContainer>
      <AdminHeader title='User Role Event' />
      <div className='page-content-wrapper scrollable'>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
            onClick={() => navigate('/user-role-events/new')}
          >
            Add User Role Event
          </Button>
        </Box>
        <Table className='table'>
          <TableHead className='tableHead'>
            <TableRow>
              <TableCell>User ID</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Event ID</TableCell>
              <TableCell>Role ID</TableCell>
              <TableCell>Entity ID</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className='tableBody'>
            {userRoleEvents.map((userRoleEvent) => (
              <TableRow key={userRoleEvent.id}>
                <TableCell>{userRoleEvent.user_id}</TableCell>
                <TableCell>{userRoleEvent.email}</TableCell>
                <TableCell>{userRoleEvent.event_id}</TableCell>
                <TableCell>{userRoleEvent.role_id}</TableCell>
                <TableCell>{userRoleEvent.entity_id}</TableCell>
                <TableCell>
                  <IconButton
                    onClick={() =>
                      navigate(`/user-role-events/edit/${userRoleEvent.id}`)
                    }
                    color='primary'
                  >
                    <EditIcon sx={{ color: '#be210b' }} />
                  </IconButton>
                  {/* <IconButton
                    onClick={() => handleDelete(userRoleEvent.id)}
                    color='secondary'
                  >
                    <DeleteIcon sx={{ color: '#be210b' }} />
                  </IconButton> */}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Snackbar
          open={notification.open}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={notification.severity}
            sx={{ width: '100%' }}
          >
            {notification.message}
          </Alert>
        </Snackbar>
      </div>
    </LayoutContainer>
  );
};

export default UserRoleEventList;
